import { Suspense, useEffect } from "react";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import i18n from "i18next";
import { ConfigProvider } from "antd";

import { Layout, LazyLoad } from "./components";
import RoutesList from "./routes";
import { useAuthMutation } from "hooks";
import { useGetQueryParams } from "./hooks";
import { useTranslation } from "react-i18next";
import { EIMZOClient } from "services/eimzo/id-card-client";

export const queryClient = new QueryClient({
	defaultOptions: {
		queries: {
			refetchOnWindowFocus: false
		}
	}
});

function App() {
	const { ticket } = useGetQueryParams();
	const auth = useAuthMutation();
	const { t } = useTranslation();

	useEffect(() => {
		EIMZOClient.installApiKeys();
	}, []);

	useEffect(() => {
		i18n.changeLanguage("uz");
		if (ticket) {
			auth();
		}
	}, []);

	useEffect(() => {
		document.title = "Солиқ органларига мурожаатлар";
	}, [t]);

	return (
		<div className={"App"}>
			<QueryClientProvider client={queryClient}>
				<ConfigProvider
					theme={{
						components: { Table: {} },
						token: { colorPrimary: "#325ECD" }
					}}>
					<Layout>
						<Suspense fallback={<LazyLoad />}>
							<RoutesList />
						</Suspense>
					</Layout>
				</ConfigProvider>
			</QueryClientProvider>
		</div>
	);
}

export default App;
